<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<!-- <app-header [headerTitle]="headerTitle"></app-header> -->

<div class="profileHeader">
    <div class="title-btn">
        <img [routerLink]="'/my-dashboard'" src="../../assets/images/backarrlibrary.svg" alt=""> <span class="learning">Profile Page
        </span>
    </div>
    <div class="profile">
        <img *ngIf="!user?.userPic" src="assets/images/user (1).png" alt="" class="profile_image">
        <img *ngIf="user?.userPic" [src]="user?.userPic" alt="" class="profile_image">
        <!-- <span>{{user?.name}}</span> -->
        <!-- <span *ngIf="firstName" class="firstName">{{ firstName }}</span> -->
        <span *ngIf="userName" class="fullName">{{ userName }}</span>
    </div>
</div>

<div class="profile_page_container">

    <form action="">
        <div class="profile_img_container">
            <!-- <img src="../../assets/images/user_profile.png" class="profile_img" alt=""> -->

            <img *ngIf="!user.userPic" src="../../assets/images/user_profile.png" class="profile_img">
            <img *ngIf="user.userPic" [src]="user.userPic" alt="" class="profile_img">

            <div class="edit-image" (click)="openDialog()">

                <img src="../../assets/images/edit.png" alt="" class="edit_icon">
                <!-- <input type="file" (change)="onFileSelected($event)" id="upload-image-btn"> -->

                <!-- <img src="../../assets/images/edit.png" alt="" class="edit_icon">
                <input type="file" (change)="onFileSelected($event)" id="upload-image-btn"> -->
            </div>

        </div>

        <div class="profile_fields_container">
            <div class="rof">
                <div class="field">Name :</div>
                <div class="input"><input [ngModelOptions]="{standalone: true}" [(ngModel)]="user.name" type="text"
                        placeholder="Name" name="name"></div>
            </div>

            <div class="rof">
                <div class="field">Role :</div>
                <div class="input"><input [ngModelOptions]="{standalone: true}" [(ngModel)]="user.role" type="text" placeholder="Role" name="role"></div>
            </div>



            <div class="rof">
                <div class="field">UserId :</div>
                <div class="input"><input [ngModelOptions]="{standalone: true}" [(ngModel)]="user.empCode ? user.empCode : user.email" type="text" placeholder="email" disabled="true" name="email"></div>
            </div>

                    <div class="rof">
                        <div class="field">Enroll Date :</div>
                        <div class="input"><input type="text" placeholder="Date" [(ngModel)]="userCreatedAt" name="date" disabled="true">
                        </div>
                    </div>

            <!-- <div class="rof">
                <div class="field">Phone Number :</div>
                <div class="input"><input type="text" placeholder="Phone number" [(ngModel)]="user.phone" name="phoneNumber"></div>
            </div> -->

            <!-- <mat-checkbox class="t_c_checkbox">
                    I agree to the terms and conditions
                </mat-checkbox> -->

            <div class="submit_btn">
				<button mat-button (click)="updateProfile()">Submit</button>
			</div>
			<div class="submit_btn" *ngIf="isuserAdmin(user.role, user.email)">
				<button mat-button (click)="deleteUserProgress()">Delete My Progress</button>
			</div>
        </div>
    </form>
</div>